export default "__VITE_ASSET__ElKmFL53__"